import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, BadgeCheck } from "lucide-react";

function MatchRow({ m }) {
  return (
    <div className="flex items-center gap-4 rounded-lg border border-slate-100 p-3.5" data-testid={`dash-match-${m.profile_id}`}>
      <div className="h-12 w-12 rounded-full bg-slate-100 flex items-center justify-center shrink-0">
        <span className="font-mono font-bold text-[#2563EB]">{m.score}</span>
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <p className="font-medium text-[#0A0F1C] truncate">{m.org_name}</p>
          {m.verified && <BadgeCheck size={15} className="text-[#2563EB] shrink-0" />}
        </div>
        <p className="text-xs text-slate-500 truncate">{m.opportunity} · {m.industry}</p>
      </div>
    </div>
  );
}

export default function TopMatches({ matches, hasProfile }) {
  const list = matches?.matches || [];
  return (
    <div className="lg:col-span-2 rounded-xl border border-slate-200 bg-white p-6">
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-lg font-bold text-[#0A0F1C]">Top AI Matches</h2>
        <Link to="/matches" className="text-sm text-[#2563EB] font-medium flex items-center gap-1" data-testid="view-all-matches">View all <ArrowRight size={14} /></Link>
      </div>
      {list.length > 0 ? (
        <div className="mt-4 space-y-3">
          {list.slice(0, 3).map((m) => <MatchRow key={m.match_id} m={m} />)}
        </div>
      ) : (
        <div className="mt-4 rounded-lg border border-dashed border-slate-200 p-8 text-center">
          <Sparkles className="mx-auto text-slate-300" size={28} />
          <p className="mt-2 text-sm text-slate-500">No matches yet. {hasProfile ? "Generate your first matches." : "Complete your profile to begin."}</p>
          <Link to="/matches" className="mt-3 inline-flex h-9 px-4 rounded-md bg-[#0A0F1C] text-white text-sm font-medium items-center hover:bg-[#1E293B] transition-colors">Go to matches</Link>
        </div>
      )}
    </div>
  );
}
